<template>
    <md-field>
        <label>{{labelText}}</label>
        <md-input v-model="value" type="text"></md-input>
    </md-field>
</template>

<script>
export default {
    props: {
        matchType: { type: String, default: "LIKE" },
        labelText: { type: String },
        columnName: { type: String },
        initialValue: { type: String, default: "" },
        sanitize: {type: Function, default: (value) => value }
    },
    data() {
        return {
            value: this.initialValue,
        };
    },
    methods: {
        clearFilter() {
            this.value = "";
        },
        getFilter() {
            if (!this.value) {
                return null;
            }

			return [{
                columnName: this.columnName,
                fieldType: "S",
                matchType: this.matchType,
                value: this.sanitize(this.value)
            }];
        },
        setFilter(filter) {
            this.value = filter.value;
        }
    },
};
</script>